import {shoppingMethod} from "../../utility/enums";
import {get, post} from "../../utility/apiClient";

/*-- Imports for redux --*/
import {store} from "../../redux/store";
import {showMessageBox} from "../../redux/actions/messageBoxActions";
import {hideLoadingScreen, showLoadingScreen,} from "../../redux/actions/loadingScreenActions";
import {addWebDataCollectionV2} from "../../redux/actions/v2.0/webDataCollectionActions";
import {addPromotionItems,} from "../../redux/actions/promotionItemsActions";
import {setPersonalizationDetails} from "../../redux/actions/v2.0/personalizationActions";
import {setPageCampaignDetails} from "../../redux/actions/v2.0/pageCampaignActions";
import {updateAlgonomyRcs} from "../../redux/actions/algonomyActions";
import {AddNexusId, addUserDetail} from "../../redux/actions/userDetailsActions";
import {addCountryCodes} from "../../redux/actions/v2.0/loadCountryCodeAction";
import {getInitialDataCollection, getSuggestedItemsInitially} from "../commonFunctions";
import {setPersonalizationData} from "../../redux/actions/v2.0/personalizationActionsv2";

export function getInitialDataCollectionV2(callback = null) {
  store.dispatch(showLoadingScreen());
  const state = store.getState();
  let shippingDetailsId =
    state.shoppingPreference.shoppingMethod === shoppingMethod.delivery
      ? state.userDetails.shippingDetailsID
      : 0;
  return get(
    `/WebV2/GetInitialDataCollection?locationCode=${state.shoppingPreference.outletCode}&shippingDetailsId=${shippingDetailsId}`
  ).then((response) => {
    if (response.data.statusCode === 200) {
      store.dispatch(addWebDataCollectionV2(response.data.result)).then(() => {
        if (response.data.result.promotionItemDetailsList.length > 0) {
          store.dispatch(
            addPromotionItems(response.data.result.promotionItemDetailsList)
          );
        }
      });
    } else {
      let messageBox = {
        show: true,
        title: "Oops!",
        className: "error",
        content: response.data.errorList[0].statusMessage,
        isConfirmation: false,
        callBackFunction: null,
      };
      store.dispatch(showMessageBox(messageBox));
    }
    store.dispatch(hideLoadingScreen());
    callback?.();
  });
}
export function getInitialDataCollectionInitiallyV2() {
  store.dispatch(showLoadingScreen());
  const state = store.getState();
  let shippingDetailsId =
      state.shoppingPreference.shoppingMethod === shoppingMethod.delivery
          ? state.userDetails.shippingDetailsID
          : 0;
  const req_1 = get(
      `/WebV2/GetInitialDataCollection?locationCode=${state.shoppingPreference.outletCode}&shippingDetailsId=${shippingDetailsId}`
  )
  const req_2 = get(
      `/WebV2/GetNavBarButtonsAndBanners`
  );
  return Promise.all([req_1, req_2])
      .then(([response_1,response_2]) => {
    if (response_1.data.statusCode === 200 && response_2.data.statusCode === 200) {
      store.dispatch(addWebDataCollectionV2({...response_1.data.result,...response_2.data.result})).then(() => {
        if (response_1.data.result.promotionItemDetailsList.length > 0) {
          store.dispatch(
              addPromotionItems(response_1.data.result.promotionItemDetailsList)
          );
        }
      });
    } else {
      let msg1 = response_1.data.errorList?.[0]?.statusMessage
      let msg2 = response_2.data.errorList?.[0]?.statusMessage
      let messageBox = {
        show: true,
        title: "Oops!",
        className: "error",
        content: msg1 || msg2 || "Unknown Error",
        isConfirmation: false,
        callBackFunction: null,
      };
      store.dispatch(showMessageBox(messageBox));
    }
    store.dispatch(hideLoadingScreen());
  });
}

export function getPersonalizationDataCollection(parameters, callback) {
  store.dispatch(showLoadingScreen());
  const state = store.getState();
  const queryParams = {
    ...parameters,
    outletCode: state.shoppingPreference.outletCode,
    rcs: state.algonomyData.rcs,
  };
  const queryString = new URLSearchParams(queryParams).toString();
  get(`/WebV2/GetPersonalizationData?${queryString}`).then((response) => {
    if (response.data.statusCode === 200) {
      store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
      store
        .dispatch(
          setPersonalizationDetails(response.data.result.personalizationDatas)
        )
        .then(() => {
          if (response.data.result.promotionItemDetailsList.length > 0) {
            store.dispatch(
              addPromotionItems(response.data.result.promotionItemDetailsList)
            );
          }
        });
    } else {
      let messageBox = {
        show: true,
        title: "Oops!",
        className: "error",
        content: response.data.errorList[0].statusMessage,
        isConfirmation: false,
        callBackFunction: null,
      };
      store.dispatch(showMessageBox(messageBox));
    }
    store.dispatch(hideLoadingScreen());
    callback();
  });
}

export function getPageCampaignDataCollection(pageId, callback) {
  store.dispatch(showLoadingScreen());
  const state = store.getState();
  get(
    `/WebV2/GetPageCampaignData?outletCode=${state.shoppingPreference.outletCode}&pageId=${pageId}`
  ).then((response) => {
    if (response.data.statusCode === 200) {
      store.dispatch(setPageCampaignDetails(response.data.result)).then(() => {
        if (response.data.result.promotionItemDetails != null) {
          if (response.data.result.promotionItemDetails.length > 0) {
            store.dispatch(
              addPromotionItems(response.data.result.promotionItemDetails)
            );
          }
        }
      });
    } else {
      let messageBox = {
        show: true,
        title: "Oops!",
        className: "error",
        content: response.data.errorList[0].statusMessage,
        isConfirmation: false,
        callBackFunction: null,
      };
      store.dispatch(showMessageBox(messageBox));
    }
    store.dispatch(hideLoadingScreen());
    callback();
  });
}

export const guestLoginV2 = () => {
  const { userDetails } = store.getState();
  const customerID = userDetails.customerID; //No need to decrypt customerID here, unless guest details are not using

  return new Promise((resolve, reject) => {
    if (customerID != 0 && customerID != null) {
      resolve(userDetails);
      return;
    }
    store.dispatch(showLoadingScreen());
    post(`/Login/GuestLogin`)
      .then((response) => {
        if (
          response.data.statusCode === 200 &&
          response.data.result.customerID > 0
        ) {
          store.dispatch(addUserDetail(response.data.result)).then(() => {
            resolve(response.data.result);
            return;
          });
        } else {
          let messageBox = {
            show: true,
            title: "Oops!",
            className: "error",
            content: response.data.errorList[0].statusMessage,
            isConfirmation: false,
            callBackFunction: null,
          };
          store.dispatch(showMessageBox(messageBox));
          resolve()
        }
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => {
        store.dispatch(hideLoadingScreen());
      });
  });
};

export const loadCountryCodesV2 = () => {
  const { countryCodes } = store.getState();
  return new Promise((resolve, reject) => {
    if (countryCodes && countryCodes.length > 0) {
      resolve(countryCodes);
      return;
    }

    store.dispatch(showLoadingScreen());
    get("/Common/GetCountryCodes")
      .then((response) => {
        if (response.data.statusCode == 200) {
          store.dispatch(addCountryCodes(response.data.result)).then(() => {
            resolve(response.data.result);
            return;
          });
        } else {
          let messageBox = {
            show: true,
            title: "Oops!",
            className: "error",
            content: response.data.errorList[0].statusMessage,
            isConfirmation: false,
            callBackFunction: null,
          };
          store.dispatch(showMessageBox(messageBox));
          resolve()
        }
      })
      .catch((error) => {
        reject(error);
      })
      .finally(() => {
        store.dispatch(hideLoadingScreen());
      });
  });
};

export const loadNexusId = async () =>{
    try {
        store.dispatch(showLoadingScreen());
       const response = await get("/Personalization/GetPersonalizedNexusId");
       store.dispatch(AddNexusId(response.data.statusCode == 200 ? response.data.result : 0));
    }catch(error) {
        let messageBox = {
            show: true,
            title: "Oops!",
            className: "error",
            content: "Nexus Id",
            isConfirmation: false,
            callBackFunction: null,
        };
        store.dispatch(showMessageBox(messageBox));
    }finally {
        store.dispatch(hideLoadingScreen());
    }

}

export const retrievePersonalizeDetailsPageWise = (pageId)=>{
  const { userDetails,personalizationdatav2,shoppingPreference } = store.getState();
  const currentTimeInMinutes = Date.now();
  let shippingDetailsId =
      shoppingPreference.shoppingMethod === shoppingMethod.delivery
          ? userDetails.shippingDetailsID
          : 0;
  let outletCode = shoppingPreference.outletCode
  const isInitialState = Array.isArray(personalizationdatav2) && personalizationdatav2.length == 0;
  const isExpired = currentTimeInMinutes > personalizationdatav2.expirationTime;
  const  isOutletChange = (outletCode != personalizationdatav2.outletCode && personalizationdatav2.outletCode != "");
  const isShippingDetailsChange = (shippingDetailsId != personalizationdatav2.shippingDetailsID && personalizationdatav2.shippingDetailsID != "");
  const isUserChanged = (userDetails.customerID != personalizationdatav2.customerID && personalizationdatav2.customerID != "");
  //Make API call
  //Product Detail external page load without any guest login, stop the api calling
  if(userDetails.customerID == 0)
    return []
  if( isInitialState || isExpired || isOutletChange || isShippingDetailsChange || isUserChanged){
    loadPersonalizedData(outletCode,shippingDetailsId,userDetails.customerID)
  }
  if(isInitialState || isOutletChange || isShippingDetailsChange || isUserChanged)
    return -1; //Special cases to change the visibility of personalized slots
  else{
    //Return data from store.
    //Scenarios : If time is expired, then solve temporary hiding issue, otherwise return cache data
    const recommendedData = personalizationdatav2?.data ?? []
    let filteredData;
    const matchedData = recommendedData.find(d => d.pageId === pageId);
    if(userDetails.isGuest){
      filteredData = matchedData ? matchedData.guestCamapignData ?? [] : [];
    }else{
      filteredData = matchedData ? matchedData.nonGuestCampaignData ?? [] : [];
    }
    return filteredData;
  }
}
export const loadPersonalizedData = (outletCode,shippingDetailsId,cusId)=>{
  const { personalizationdatav2,userDetails } = store.getState()
  const id = crypto.randomUUID().replace(/-/g, '').slice(0, 20);
  store.dispatch(showLoadingScreen());
    get(`/Personalization/GetPersonalizedData?code=${outletCode}&correlationId=${id}`,1.0)
        .then((response)=>{
          if (response.data.statusCode == 200){
            //If success dispatch data
            store.dispatch(setPersonalizationData(
                {
                  data: response.data.result.personalizationResults ?? [],
                  outletCode: outletCode,
                  shippingDetailsID: shippingDetailsId,
                  correlationId: id,
                  customerID: cusId,
                  isGuest: userDetails.isGuest,
                  categories: response.data.result.categories ?? [],
                })
            );
          }else{
            //If API fails We can't display error message
            ((Array.isArray(personalizationdatav2) && personalizationdatav2.length == 0)
                || personalizationdatav2?.isGuest != userDetails.isGuest
                || personalizationdatav2?.shippingDetailsID != shippingDetailsId
                || personalizationdatav2?.outletCode != outletCode
                || personalizationdatav2?.customerID != cusId
            ) ?
                // Cover special scenarios,where need to remove existing data
                // Scenarios : Initial state/Account change/outlet change
                store.dispatch(setPersonalizationData(
                    {
                      data: [],
                      outletCode: "",
                      shippingDetailsID: "",
                      correlationId: id,
                      customerID: "",
                      isGuest: "",
                      categories: [],
                    }
                ))
                :
                // Cover special scenarios,where need to keep existing data
                // Scenario : API fails but user still in the same outlet/delivery address/account etc
                store.dispatch(setPersonalizationData(
                    {
                      data: personalizationdatav2.data,
                      outletCode: personalizationdatav2.outletCode,
                      shippingDetailsID: personalizationdatav2.shippingDetailsID,
                      correlationId: id,
                      customerID: personalizationdatav2.customerID,
                      isGuest: personalizationdatav2?.isGuest,
                      categories: [],
                    }))
          }
        })
        .catch((error) => {})
        .finally(() => {
          store.dispatch(hideLoadingScreen());
        })
}

export const loadInitialDataForceFully = ()=>{
  return Promise.all([getInitialDataCollection(),getInitialDataCollectionV2(),getSuggestedItemsInitially()])
}
